module.exports = __webpack_public_path__ + "media/1x1/jo-51302798.svg";